import { render, staticRenderFns } from "./CoachingInfractions.vue?vue&type=template&id=3f482792&"
import script from "./CoachingInfractions.vue?vue&type=script&lang=js&"
export * from "./CoachingInfractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports